import { useLocation, Redirect } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React example components
import BasicLayout from "../components/BasicLayout";
import Footer from "examples/Footer";

import ClockTime from "./components/ClockTime";

function DashClockTime() {
  return (
    <BasicLayout
      gotoPage="/admin"
      action={{
        type: "internal",
        label: "Logout",
        route: "/",
        exec: () => {
          localStorage.clear();
        },
        color: "white",
      }}
    >
      <Grid item xs={12} lg={7} xl={12}>
        <ClockTime />
      </Grid>
      <Footer />
    </BasicLayout>
  );
}

function CheckLogin() {
  const location = useLocation();
  const isLoggedStorage = localStorage.getItem("logged");
  return isLoggedStorage ? (
    <DashClockTime />
  ) : (
    <Redirect
      to={
        "/login?redirect=" +
        location.pathname +
        (location.search !== "" ? `${location.search}` : "")
      }
    />
  );
}

export default CheckLogin;
